module.exports = __webpack_public_path__ + "img/facebook.3935080.png";